import { MaterialTheme } from "../.internal/themes/MaterialTheme";
export default MaterialTheme;
//# sourceMappingURL=Material.js.map